import debug from 'debug';

const log = debug('post-message');

export default {
  post({ ev, data }) {
    log(ev, data);
    window.parent.postMessage({
      ev,
      data,
    }, '*');
  },
};
